import { createSelector } from 'reselect';

const stateClaimSelector = (state) => state.claim;

export const claimSelector = createSelector(
    [stateClaimSelector],
    (claim) => {
        return { ...claim };
    }
);